module.exports = __webpack_public_path__ + "static/img/yysj.e0d293d3.png";